<template>
  <div class="snippet">
    <nav class="navbar navbar-light bg-light border-bottom">
      <div class="container-fluid">
        <div class="navbar-brand">{{ snippet.title }}</div>

        <div class="nav-item" v-b-modal="'edit-snippet'">
          <div class="btn btn-outline-secondary">
            <b-icon-pencil></b-icon-pencil>
          </div>
        </div>
      </div>
    </nav>
    
    <Modal id="edit-snippet">
      <template v-slot:header>
        Edit {{ snippet.title }}
      </template>

      <template v-slot:content="{ changed, close }">
        <Editor :snippet="snippet" v-on="{ changed, saved: updated(close) }"></Editor>
      </template>
    </Modal>
    
    <div class="snippet-content-container">
      <div class="snippet-content">
        <Empty v-if="$apollo.queries.snippet.loading" icon="b-icon-hourglass-split" header="Loading"></Empty>
        <Pane :type="'snippet'" :body="snippet.body" v-else v-on:positioned="positioned" />
      </div>
    </div>
  </div>
</template>

<script>
  import gql from 'graphql-tag'

  import Pane from '../components/Pane';
  import Modal from '../components/Editor';
  import Editor from '../components/editors/Snippet';
  import Empty from '../components/Empty';

  export default {
    components: {
      Pane,
      Modal,
      Editor,
      Empty
    },

    beforeRouteUpdate(to, from, next) {
      this.id = to.params.snippetId;
      next();
    },

    beforeDestroy() {
      this.$store.dispatch('frameClosed');
    },

    data() {
      return {
        id: this.$route.params.snippetId,
        snippet: {}
      }
    },

    methods: {
      positioned(position) {
        this.$store.dispatch('positioned', position)
      },

      updated(callback) {
        return function({ updated_at }) {
          callback();
          this.$store.dispatch('updated', updated_at)
        }.bind(this);
      }
    },  

    apollo: {
      snippet: {
        query: gql`
          query GetSnippet($id: uuid!) {
            snippet: snippets_by_pk(id: $id) {
              id
              title
              body
              created_at
              updated_at
            }
          }
        `,

        variables() {
          return {
            id: this.id
          }
        },

        result({ data : { snippet } }) {
          this.$store.dispatch('frameOpened', { type: 'snippet', id: snippet.id, timestamp: snippet.updated_at })
        }
      }
    }
  }
</script>

<style scoped>
  .snippet {
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  .snippet-content-container {
    display: flex;
    flex: 1;
    min-height: 0;
  }

  .snippet-content {
    flex: 1;
    overflow: auto;

    position: relative;
  }
</style>
